// assets/infinite-scroll.js
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    const GRID_SELECTORS = ['#product-grid','#ProductGrid','.product-grid','.collection__products','.grid--collection'];
    const PAGINATION_SELECTORS = ['#pagination','.pagination','.pagination-wrapper','nav[role="navigation"]'];
    const triggerSelector = '#infinite-scroll-trigger';
    const fallbackButtonId = 'infinite-load-more-btn';
    const loadingClass = 'infinite-loading';

    const productGrid = GRID_SELECTORS.map(s=>document.querySelector(s)).find(Boolean);
    const paginationEl = PAGINATION_SELECTORS.map(s=>document.querySelector(s)).find(Boolean);
    const trigger = document.querySelector(triggerSelector);

    if (!productGrid || !trigger) return;

    let fallbackBtn = document.getElementById(fallbackButtonId);
    let loadingEl = trigger.querySelector('.' + loadingClass);
    if (!fallbackBtn) {
      fallbackBtn = document.createElement('button');
      fallbackBtn.id = fallbackButtonId;
      fallbackBtn.type = 'button';
      fallbackBtn.textContent = 'Load more';
      fallbackBtn.style.display = 'none';
      trigger.appendChild(fallbackBtn);
    }
    if (!loadingEl) {
      loadingEl = document.createElement('div');
      loadingEl.className = loadingClass;
      loadingEl.textContent = 'Loading…';
      loadingEl.style.display = 'none';
      trigger.appendChild(loadingEl);
    }

    const paginationWrapper = paginationEl || document.querySelector(PAGINATION_SELECTORS.join(','));
    let loading = false;
    let observer;
    let endReached = false;

    function findNextUrl(fromEl){
      const el = fromEl || paginationWrapper || document;
      if(!el) return null;
      const anchors = Array.from(el.querySelectorAll('a')).filter(a=>a.href);
      let next = anchors.find(a => a.rel === 'next');
      if(!next) next = anchors.find(a => /next/i.test(a.getAttribute('aria-label')||''));
      if(!next) next = anchors.find(a => /next/i.test(a.className||''));
      if(!next) next = anchors.find(a => /\bnext\b/i.test((a.textContent||'').trim()));
      return next ? next.href : null;
    }

    async function loadNext(){
      if(loading || endReached) return;
      const nextUrl = findNextUrl();
      if(!nextUrl){
        reachEnd();
        return;
      }
      loading = true;
      fallbackBtn.style.display='none';
      loadingEl.style.display='block';

      try {
        const res = await fetch(nextUrl, {credentials: 'same-origin'});
        if(!res.ok) throw new Error('Network response was not ok');
        const text = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const docGrid = GRID_SELECTORS.map(s=>doc.querySelector(s)).find(Boolean);
        if(docGrid){
          const items = Array.from(docGrid.children);
          items.forEach(node=>{
            const imported = document.importNode(node, true);
            productGrid.appendChild(imported);
          });
        }

        const newPagination = PAGINATION_SELECTORS.map(s=>doc.querySelector(s)).find(Boolean);
        if(newPagination){
          if(paginationEl) paginationEl.innerHTML = newPagination.innerHTML;
        } else {
          reachEnd();
        }

        window.dispatchEvent(new CustomEvent('infinite-scroll:items-added'));
      } catch(err){
        console.error('Infinite scroll fetch error', err);
        fallbackBtn.style.display='inline-block';
      } finally {
        loadingEl.style.display='none';
        loading = false;
      }
    }

    function reachEnd(){
      endReached = true;
      if(observer) observer.disconnect();
      fallbackBtn.style.display='none';
      loadingEl.style.display='none';
      trigger.innerHTML = `<div style="padding:20px; color:#666;">You’ve reached the end 🚀</div>`;
    }

    fallbackBtn.addEventListener('click', loadNext);

    if('IntersectionObserver' in window){
      observer = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            loadNext();
          }
        });
      }, {rootMargin: '500px'});
      observer.observe(trigger);
    } else {
      window.addEventListener('scroll', function onScroll(){
        if(loading || endReached) return;
        const rect = trigger.getBoundingClientRect();
        if(rect.top - window.innerHeight < 500) loadNext();
      });
    }
  });
})();
